import { __makeTemplateObject } from "tslib";
import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
/**
 * The `Card` is meant to hold content and actions around a certain subject. Use this component for things like dashboard widgets and status widgets.
 * It automatically wraps the content in a `.card-body` and by default, the border will be positioned at the top of the card.
 *
 * Aside from the `.card-body`, you can use any of the inner card components provided by https://reactstrap.github.io/components/card/
 */
export var Card = function (_a) {
    var borderPosition = _a.borderPosition, borderColor = _a.borderColor, children = _a.children, delay = _a.delay, primary = _a.primary, className = _a.className;
    var _b = useState(false), isAnimated = _b[0], toggleAnimation = _b[1];
    useEffect(function () {
        setTimeout(function () { return toggleAnimation(true); }, delay);
    }, [delay]);
    return (React.createElement(CardWrapper, { borderPosition: borderPosition, borderColor: borderColor, delay: delay, animated: isAnimated, primary: primary, className: className },
        React.createElement(CardBody, { borderPosition: borderPosition, primary: primary }, children)));
};
Card.defaultProps = {
    borderPosition: 'top',
    borderColor: 'primary',
    delay: 0,
};
export default Card;
var CardBody = styled.div.attrs(function (_a) {
    var borderPosition = _a.borderPosition, primary = _a.primary;
    var classes = ['card-body', 'border', "" + (primary ? 'border-primary' : '')];
    if (borderPosition === 'top') {
        classes.push('border-top-0', 'rounded-bottom');
    }
    else {
        classes.push('border-left-0', 'rounded-right');
    }
    return {
        className: classes.join(' '),
    };
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var animatedCss = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    opacity: 1;\n    transform: translateY(0);\n"], ["\n    opacity: 1;\n    transform: translateY(0);\n"])));
var CardWrapper = styled.div.attrs(function (_a) {
    var borderColor = _a.borderColor, borderPosition = _a.borderPosition, primary = _a.primary, className = _a.className;
    var classes = [
        className,
        'card', 'border-right-0', 'border-bottom-0',
        "border-" + (!primary ? borderColor : 'warning'),
        "" + (primary ? 'text-white' : '')
    ];
    if (borderPosition === 'top')
        classes.push('border-left-0');
    else
        classes.push('border-top-0');
    if (primary)
        classes.push('bg-primary');
    return { className: classes.join(' ').trim() };
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border-radius: 0;\n    border-width: 5px;\n    opacity: 0;\n    transform: translateY(50px);\n    transition: 300ms all cubic-bezier(0.4, 0.0, 0.2, 1);\n    ", ";\n"], ["\n    border-radius: 0;\n    border-width: 5px;\n    opacity: 0;\n    transform: translateY(50px);\n    transition: 300ms all cubic-bezier(0.4, 0.0, 0.2, 1);\n    ", ";\n"])), function (props) { return props.animated && animatedCss; });
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Card.js.map